import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../../components/Error/error';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import Moment from 'moment';
import {DropDownList} from '../../Elements/Select/dropdown';
import ResourcePagination from '../../Elements/Pagination/resourcepagination';
import $ from "jquery";
import { Pagination } from '../../Elements/Pagination/tablePagination';
import { DropDownListChildMaster } from '../../Elements/Select/dropdownChild';
import { DropDownListMaster } from '../../Elements/Select/dropdownChild';

// El texto de cada estado ya no se hardcodea acá: sale de tblParametro vía
// ParameterUX/ESTADO-RECURSO (mismo endpoint que ya usa el filtro de Estado más
// abajo, componente={"Estado"}). Solo se mantiene fijo el className por código,
// que es estilo visual y no dato de negocio. Si el mapa aún no cargó o no trae
// el código, se muestra el propio código como respaldo en vez de dejar la celda
// vacía o reventar.
function Estado(key, estadosMap){
    const claseCss = {
        "R": "label-info-res_estado_R",
        "X": "label-info-res_estado_X",
        "O": "label-info-res_estado_O",
        "P": "label-info-res_estado_P",
        "Z": "label-info-res_estado_Z",
        "I": "label-info-res_estado_I",
    }[key] || "label-info-res_estado_R";

    const texto = (estadosMap && estadosMap[key]) ? estadosMap[key] : key;

    return <span className={`label ${claseCss}`}>{texto}</span>;
}

export default class Recurso extends Component {

    handleInputChange(event) {
    const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name; // Extraemos el nombre del input ("nCategoria", etc.)

        this.setState({ [name]: value }, () => {});
    }

    handleInputTextChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        // Colapsa espacios múltiples entre palabras a uno solo (ej. "Marca     país" -> "Marca país"),
        // ya que el filtro de título no devuelve resultados cuando hay más de un espacio consecutivo.
        const valorNormalizado = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;

        this.setState({ sTitulo: ((valorNormalizado==='') ? ('ALL') : (valorNormalizado))});
    }

    constructor (props){
        super(props);
        this._isMounted = false; // 1. Creamos la bandera
        // ... el estado inicial ...
        this.state = {
            resource:               [],
            response:               [],
            optionsTipoRecurso:     [],
            error:                  [],
            security:               cookie.load('user'),
            menu:                   localStorage.getItem("usermenu"),
            roles:                  [],
            nTipoRecursoCodigo :    '0',
            sTitulo :               'ALL',
            nCategoria: 0,
            nUsuario: 0,
            sEstado: 0,
            estadosMap:             {},
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputTextChange = this.handleInputTextChange.bind(this);
    }

    editResource(id){

        this.props.history.push({
            pathname: '/edit-recurso/' + id,
            state: { key: id }
          });
    }

    addResource(){
        this.props.history.push({
            pathname: '/add-recurso/',
            state: { key: 0}
          });
    }

    searchResource(page = '1', search = "ALL"){

        if(search === "" || search === null){search = "ALL";}

        const menu          = JSON.parse(this.state.menu);
        const roleRecursos  = menu.find(itemmenu => itemmenu.sAgrupador === 'Recursos');
        const isAdminRecursos = roleRecursos ? roleRecursos.sMenu.find(itemRole => itemRole.sOpcNombre === "Gestor de Recursos") : null;

        var usuario         = this.state.security;
        // let codUsuario      = (isAdminRecursos) ? 0 : usuario.nUsuCodigo;
        console.log(this.state.nCategoria, this.state.nUsuario.value, this.state.sEstado.value)

        // let codCategoria    = this.state.nCategoria > 0 ? this.state.nCategoria : 0;
        let codCategoria = this.state.nCategoria?.value > 0 ? this.state.nCategoria.value : (this.state.nCategoria > 0 ? this.state.nCategoria : 0);
        let codUsuario      =  this.state.nUsuario.value > 0 ? this.state.nUsuario.value : 0;
        let sEstado       = this.state.sEstado.value ? this.state.sEstado.value : "0";
        const url = `${API_URL}ResourceUX/${page}/${sEstado}/${codUsuario}/0/${codCategoria}/${search}`;
        console.log(url)

        axios.get(url).then(response => response.data)
        .then((data) => {

            // 5. Si el componente ya se desmontó, ignoramos los datos
            if (!this._isMounted) return;

            if (search != "ALL"){
                if(data.result.length > 0){
                    toast.success(`Se han encontrado ${data.result.length} resultados`)
                }else{
                    toast.error("No se encontraron resultados para la busqueda")
                }
            }

            this.setState({
                resource: data.result,
                response: data,
                error: data.Error,
                pagina: page
            }, () => {
                document.querySelector('.loader').classList.add('loader--hide');
                document.getElementById('content-wrapper').removeAttribute("hidden");
            });

        }).catch(error => {
            //document.querySelector('.loader').classList.add('loader--hide');
            toast.error('Error de comunicación');
        });
    }

    // Carga el texto real de cada estado desde tblParametro (mismo origen que ya
    // usa el filtro de Estado del listado), para no tener el texto duplicado y
    // hardcodeado en el frontend.
    cargarEstados(){
        axios.get(`${API_URL}ParameterUX/ESTADO-RECURSO`).then(response => response.data)
        .then((data) => {
            if (!this._isMounted) return;
            if (data.isSucess && data.result){
                const mapa = {};
                data.result.forEach(item => { mapa[item.sClave] = item.sValor; });
                this.setState({ estadosMap: mapa });
            }
        }).catch(error => {
            console.log(error);
            // Sin toast acá a propósito: si falla, Estado() ya cae de vuelta al
            // código (ej. "O") en vez de dejar la columna vacía o romper la tabla.
        });
    }

    componentDidMount(){
        this._isMounted = true; // 3. Encendemos la bandera
        var flag = localStorage.getItem("load");

        // Unificamos la validación
        if (flag === false || flag === "false" || localStorage.getItem("load") === null) {
            localStorage.setItem("load", true);
            window.location.reload();
            return; // 4. ¡CRUCIAL! Esto detiene el código y evita que Axios se dispare en vano
        }

        $(".divContenidoPanelNav").animate({"left": "-510px"});
        this.searchResource();
        this.cargarEstados();
    }

    // -----> AQUÍ PEGAS EL NUEVO MÉTODO <-----
    componentWillUnmount() {
        this._isMounted = false;
    }
    // ----------------------------------------

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            this.state.response.statusCode == 200 ?
                <div id="detailBody" className="Site-content" >
                    <div className="loader"></div>
                    <div hidden={true} id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <div id="Body" className="body-container">
                                     <div className="divContenedorBreadcrumbs">
                                        <div className="divCenterBreadcrumbs">
                                            <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                                <a href="/">
                                                    / Panel de configuración general
                                                </a>
                                            <span> / Documentos</span>
                                        </div>
                                    </div>
                                    <div className="divTitulo_Panel mb-3">
                                        Documentos
                                    </div>
                                <div className="content-option col-sm-12 col-lg-11 mx-auto" >
                                    <div className="row recursos__search mb-2">
                                        <div className="col-sm-12">
                                            <div className="col-md-2 px-1">
                                                <button 
                                                    className="btn btn-success btn-primary__submit" 
                                                    style={{ width: '160px', height: '38px', padding: '0px' }} 
                                                    onClick={() => this.addResource()} 
                                                    type="button"
                                                >
                                                Nuevo
                                                </button>
                                            </div>
                                            
                                            <div className="ibox-content mt-2">
                                                <div className="search-form mt-2 pb-2" >
                                                    
                                                    <div className="row no-gutters align-items-center">

                                                        {/* Filtro titulo:  */}
                                                        <div className="col-md-3 px-1">
                                                                <input
                                                                    type="text"
                                                                    placeholder="Ingrese el título del documento"
                                                                    onChange={this.handleInputTextChange}
                                                                    name="search"
                                                                    className="recursos__search-form-control form-control input-lg res_input_filtro"
                                                                    style={{ paddingLeft: '10px' }}
                                                                />
                                                        </div>

                                                        {/* Filtro  : categ */}
                                                        <div className="col-md-2 px-1">
                                                            <div className="ocultar"> 
                                                                <DropDownListMaster 
                                                                    valor={this.state.nTipoRecursoCodigo || ''} 
                                                                    child="Categoria" 
                                                                    name="nTipoRecursoCodigo" 
                                                                    id="nTipoRecursoCodigo"  
                                                                    onChange={this.handleInputChange} 
                                                                    clave={15} 
                                                                    componente={"TipoRecurso"} 
                                                                /> 
                                                            </div>
                                                            <DropDownListChildMaster  
                                                                isMulti={false}  
                                                                valor={this.state.nCategoria || ''}  
                                                                name="nCategoria" 
                                                                onChange={this.handleInputChange}  
                                                                parent="TipoRecurso" 
                                                                id="nCategoria" 
                                                                componente={"Categoria"} 
                                                                placeholder="Seleccione la temática" 
                                                            />
                                                        </div>

                                                        {/* Filtro  : usuario  */}
                                                        <div className="col-md-2 px-1">
                                                            <DropDownList 
                                                                metodo={"add"} 
                                                                valor={this.state.nUsuario || ''} 
                                                                name="nUsuario" 
                                                                id="nUsuario" 
                                                                onChange={this.handleInputChange} 
                                                                componente={"UsuarioRecurso"}  
                                                                placeholder="Seleccione el usuario"  
                                                            />
                                                        </div>

                                                        {/* Filtro  :  Estado */}
                                                        <div className="col-md-2 px-1">
                                                            <DropDownList 
                                                                metodo={"add"} 
                                                                valor={this.state.sEstado || ''} 
                                                                name="sEstado" 
                                                                id="sEstado" 
                                                                onChange={this.handleInputChange} 
                                                                componente={"Estado"}  
                                                                placeholder="Seleccione el estado" 
                                                            />
                                                        </div>

                                                        <div className="col-md-2 px-1">
                                                            <button 
                                                                className="btn btn-primary btn-primary__submit" 
                                                                style={{ width: '160px', height: '38px', padding: '0px' }} 
                                                                onClick={() => this.searchResource("1", this.state.sTitulo)} 
                                                                type="submit"
                                                            >
                                                            Buscar
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        <div className="divTablaPage_Panel">
                                            <div className="table-responsive">
                                            <table  border={1} cellSpacing={0}>
                                                <thead>
                                                    <tr>
                                                        <th>Título del documento</th>
                                                        <th>Categoría</th>
                                                        <th>Fecha de creación</th>
                                                        <th>Sector(es)</th>
                                                        <th>Usuario creador</th>
                                                        <th className="text-center">Estado</th>
                                                        <th className="table-bordered-radius--right text-center">Gestión</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.resource.map((resource) => {
                                                    return <tr key={resource.nRecursoCodigo}>
                                                        <td>{resource.sTitulo}</td>
                                                        <td>{resource.sDescripcionTipoRecurso}</td>
                                                        <td>{Moment(resource.dFechaCreacion).format('DD/MM/YYYY')}</td>
                                                        <td>{resource.sSector}</td>
                                                        <td>{resource.sUsuario}</td>
                                                        <td className={`text-center`} style={{ whiteSpace: 'nowrap' }} >
                                                            {Estado(resource.cEstado, this.state.estadosMap)}
                                                        </td>
                                                        {/* <td className="text-center">
                                                            {(resource.bActivo?<span className="label label-info">ACTIVO</span>:<span className="label label-warning">INACTIVO</span>)}
                                                        </td> */}
                                                        <td className="recursos__table-action-option">
                                                            {/* <button onClick={() => this.editResource(resource.nRecursoCodigo)} className="btn btn-primary btn-primary__tool" type="button"><i className="fas fa-pen fa-sm"></i></button> */}
                                                            <img style={{width:'30px', 'cursor':'pointer'}} src="/static/images/editar-icon-40x38.png" alt="" onClick={() => this.editResource(resource.nRecursoCodigo)}  /> 
                                                        </td>
                                                    </tr>
                                                })}
                                                </tbody>
                                            </table>
                                            {this.state.resource.length > 0 &&
                                                <Pagination
                                                    data={this.state.resource}
                                                    pagina={this.state.pagina}
                                                    changePage={(page) => this.searchResource(page, this.state.sTitulo)}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            :
                <Error StatusCode={this.state.response.StatusCode} StatusMessage={this.state.response.StatusMessage}></Error>

        );
    }
}
